import { defineMessages } from "react-intl";

const messages = defineMessages({
  error: {
    id: "fileStorage.components.internalServer.error",
    defaultMessage: "An internal server error has occurred.",
  },
  errorMessage: {
    id: "fileStorage.components.internalServer.errorMessage",
    defaultMessage: `Please try again. If issue persists contact the Apex Business Automation Team.`,
  },
});

export default messages;
